import EvalImportDrawer from './src/main';

/* istanbul ignore next */
EvalImportDrawer.install = function(Vue) {
  Vue.component(EvalImportDrawer.name, EvalImportDrawer);
};

export default EvalImportDrawer;
